import { render, staticRenderFns } from "./PlatformDatePicker.vue?vue&type=template&id=3a0440ef"
import script from "./PlatformDatePicker.vue?vue&type=script&lang=ts"
export * from "./PlatformDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports